/**
 * Function to generate a random color in hexadecimal format.
 * @returns {string} - Random hex color code.
 */
export const getRandomColor = () => {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
};

/**
 * Formats a number with commas as thousand separators.
 *
 * @param num - The number to format.
 * @returns The formatted number as a string with commas.
 *
 * @example
 * ```typescript
 * formatNumberWithCommas(1234567); // "1,234,567"
 * formatNumberWithCommas(1000);    // "1,000"
 * formatNumberWithCommas(123.45);  // "123.45"
 * ```
 */
function formatNumberWithCommas(num: number): string {
    return num.toLocaleString("en-US");
}

export default formatNumberWithCommas;

/**
 * Transforms API response to match the desired rtoOfficesMapCoordinates structure.
 *
 * @param {Array} apiResponse - The API response array.
 * @returns {Array} - Transformed array with desired structure.
 */
export const transformMapApiResponse = (apiResponse) => {
    return apiResponse.map((item) => ({
        code: item.code || item.rto,
        vehicles: item.metric_value, // Map 'metric_value' to 'vehicles'
        coordinates: [item.latitude || 0, item.longitude || 0], // Combine latitude and longitude into 'coordinates'
    }));
};
export const getOrdinal = (n: number): string => {
    if (n < 0 || n > 500) {
        throw new Error("Input must be between 0 and 500");
    }

    // Handle special cases: 11th, 12th, 13th
    if (n % 100 >= 11 && n % 100 <= 13) {
        return `${n}th`;
    }

    // Determine suffix based on the last digit
    switch (n % 10) {
        case 1:
            return `${n}st`;
        case 2:
            return `${n}nd`;
        case 3:
            return `${n}rd`;
        default:
            return `${n}th`;
    }
};
